import React from 'react'
import classnames from 'classnames'

const AccordionSectionHeader = ({ children, className }) => (
  <div className={
    classnames(
      'vs-accordion__section-header',
      className
    )}
  >
    {children}
  </div>
)

export default AccordionSectionHeader
